import { FormControl } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import ModalUsuarioMotorista from "../../../../components/ModalUsuarioMotorista/ModalUsuarioMotorista.tsx";
import ModalVincular from "../../../../components/ModalVincular/ModalVincular.tsx";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import Layout from "../../../../core/layout/Layout.tsx";
import { documentoValido } from "../../../../core/utils/validators.ts";
import { ProprietarioModel } from "../../../../models/ProprietarioModel";
import { cnpjMask } from "../../../../regex/cnpjMask";
import { cpfMask } from "../../../../regex/cpfMask";
import {
	cadastraProprietario,
	deleteProprietarioPorId,
	editaProprietarioPorId,
	getProprietario,
	getProprietarioPorId,
} from "../../../../services/ModuloGerenciador/Proprietario";
import { getProprietarioSearch } from "../../../../services/ModuloGerenciador/Search";
import {
	getUserClientes,
	vincularUsuario,
} from "../../../../services/ModuloGerenciador/Usuario";
import TipoContatoProp from "../TipoContatoProp/TipoContatoProp.js";
import "./Proprietario.css";

const itensFiltro = [
	{
		nomeColuna: "Nome",
		field: "Nome",
	},
	{
		nomeColuna: "CNPJ",
		field: "Cnpj",
	},
];

function Proprietario(props) {
	const { profile, hasRegra, tabelaEmpresa, shouldSearchDependencies } =
		useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(false);

	const [values, setValues] = useState(new ProprietarioModel({}));

	const [dadosUsuarioMotorista, setDadosUsuarioMotorista] = useState([]);

	const [validator, setValidator] = useState({
		nome: "true",
		cnpj: "true",
	});

	const opcoesTipoProprietario = [
		{
			opcao: "ETC",
			valor: 2,
		},
		{
			opcao: "ETC - Equiparado",
			valor: 1,
		},
	];

	const opcoesSelect = opcoesTipoProprietario.map((data) => ({
		value: data.valor,
		label: data.opcao,
		...data,
	}));

	const label = (data) => <div>{data.opcao}</div>;

	const estiloVeiculo = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "160px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const customStylesErro = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "160px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const [erroTipoProp, setErroTipoProp] = useState(false);

	const [isTipoProp, setIsTipoProp] = useState(false);

	const [valuesSelect, setValuesSelect] = useState([]);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [openUsuario, setOpenUsuario] = useState(false);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [cnpjMascara, setCnpjMascara] = useState("");

	const [cidadeObjeto, setCidadeObjeto] = useState([]);

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const [openUsuarioMotorista, setOpenUsuarioMotorista] = useState(false);

	const handleCloseUsuarioMotorista = (value) => {
		setOpenUsuarioMotorista(false);
		setOpenConfirmar(false);
		buscarEmpresa();
	};

	const abrirConfirmar = (value) => {
		setOpenConfirmar(true);
	};

	const [openConfirmar, setOpenConfirmar] = useState(false);

	const handleCloseConfirmar = (value) => {
		setOpenConfirmar(false);
	};

	const clickGerar = () => {
		gerarUsuario();
	};

	const [listaUsuarios, setListaUsuario] = useState([]);

	const [usuarioId, setUsuarioId] = useState();

	const [nomeUsuario, setNomeUsuario] = useState();

	const [openGerar, setOpenGerar] = useState(false);

	const handleCloseGerar = (value) => {
		setOpenGerar(false);
	};

	const buscarEmpresa = async () => {
		setLoading(true);
		await getProprietario(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setDadosTabelaCopia(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const [propId, setPropId] = useState(0);

	const preencherDadosEditando = async (result) => {
		let tipoProprietario;
		if (result.data.tipoProprietario) {
			if (result.data.tipoProprietario === 2) {
				tipoProprietario = "ETC";
			} else if (result.data.tipoProprietario === 1) {
				tipoProprietario = "ETC - Equiparado";
			}
		}

		const tipoProprietarioSelecionado = opcoesSelect.find(
			(option) => option.label === tipoProprietario
		);

		if (tipoProprietarioSelecionado) {
			setValues((current) => ({
				...current,
				tipoProprietario: tipoProprietarioSelecionado.valor,
			}));
			setValuesSelect((current) => ({
				...current,
				tipoProprietario: tipoProprietarioSelecionado,
			}));
			setValidator((current) => ({
				...current,
				tipoProprietario: "true",
			}));
			setTimeout(() => {
				setErroTipoProp(false);
			}, 500);
		}
	};

	const buscarEmpresaPorID = async () => {
		await getProprietarioPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						preencherDadosEditando(result);
						setPropId(result.data.idProprietario);
						setCidadeObjeto(result.data.cidadeEstado);
						setCnpjMascara(cnpjMask(result.data.cnpj));
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				}
			});
	};

	const buscarEmpresaPorIDModal = async (id) => {
		await getProprietarioPorId(id, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setValues(result.data);
					setCidadeObjeto(result.data.cidadeEstado);
					setCnpjMascara(cnpjMask(result.data.cnpj));
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				}
			});
	};

	const buscarUsuariosClientes = async () => {
		await getUserClientes(profile?.token)
			.then((result) => {
				setListaUsuario(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Proprietário";
		if (telaCadastro) return "Cadastro de Proprietário";
		return "Proprietários";
	}, [editando, telaCadastro]);

	const gerarUsuario = async () => {
		const usuarioVinculo = {
			proprietarioId: tabelaRedux.colunaSelecionada,
			usuarioClientesId: usuarioId,
		};
		await vincularUsuario(usuarioVinculo, profile?.token)
			.then((result) => {
				setOpenGerar(false);
				buscarEmpresa();
				setTextoSucesso("Vinculado Com Sucesso");
				setOpenToastSucesso(true);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		setOpenToastErro(false);
		if (!values.tipoProprietario && erroTipoProp) {
			setErroTipoProp(true);
			return;
		}

		if (!documentoValido(values.cnpj)) {
			setTextoErro("CNPJ/CPF inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, cnpj: "false" }));
			return;
		}

		setLoading(true);
		if (!!values.nome && validator.nome === "true") {
			await cadastraProprietario(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						if (!valuesPesquisa.pesquisa) {
							buscarEmpresa();
						} else {
							buscarSearch();
						}
						shouldSearchDependencies();
						setTelaCadastro(false);
						setValues({});
						setValuesSelect({});
						setCnpjMascara("");
						setDadosRequestControllerRedux("Fechar Modal Proprietario");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error?.response?.data === "string") {
						setTextoErro(error.response.data);
					} else if (typeof error?.response?.data?.data === "string") {
						setTextoErro(error.response.data.data);
					} else if (typeof error?.response?.data?.status === "string") {
						setTextoErro(error.response.data.status);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
		}
		setLoading(false);
	};

	const editar = async () => {
		setOpenToastErro(false);
		if (!values.tipoProprietario && erroTipoProp) {
			setErroTipoProp(true);
			return;
		}

		if (!documentoValido(values.cnpj)) {
			setTextoErro("CPF/CNPJ inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, cnpj: "false" }));
			return;
		}

		setLoading(true);
		await editaProprietarioPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (valuesPesquisa.pesquisa === undefined) {
						buscarEmpresa();
					} else {
						buscarSearch();
					}
					setTabelaRedux({});
					setTextoSucesso("Editado Com Sucesso");
					setOpenToastSucesso(true);
					setEditando(false);
					setTelaCadastro(false);
					setValues({});
					setValuesSelect({});
					setCnpjMascara("");
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const deletarEmpresa = async () => {
		setLoading(true);
		await deleteProprietarioPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarEmpresa();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		setValues((current) => ({ ...current, usuario: profile?.usuario.usuario }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarEmpresaPorID();
		}
		setLoading(true);
		setTimeout(() => setLoading(false), 2000);
	}, [editando]);

	useEffect(() => {
		setLoading(true);
		setTimeout(() => setLoading(false), 2000);
	}, [telaCadastro]);

	useEffect(() => {
		if (profile?.token) {
			if (props.idAtual) {
				buscarEmpresaPorIDModal(props.idAtual);
			}
			buscarEmpresa();
			buscarUsuariosClientes();
		}
	}, [profile?.token]);

	useEffect(() => {
		if (props.telaCadastro === true) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	useEffect(() => {
		const replace = values?.cnpj?.replace(".", "").replace("-", "");

		if (replace?.length >= 13) {
			setIsTipoProp(true);
			if (!valuesSelect?.tipoProprietario) {
				setErroTipoProp(true);
			}
			return;
		}
		setErroTipoProp(false);
		setIsTipoProp(false);
		setValuesSelect({});
	}, [values.cnpj]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const [semAutorizacaoGerarLogin, setSemAutorizacaoGerarLogin] =
		useState(false);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopia);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getProprietarioSearch(profile?.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const handleChangeDocumento = useCallback(
		(e) => {
			let valorMascara = e.target.value.replace(/\D+/g, "");
			if (valorMascara.length <= 11) {
				valorMascara = cpfMask(valorMascara);
			} else {
				valorMascara = cnpjMask(valorMascara);
			}
			setValues((current) => ({
				...current,
				cnpj: valorMascara,
			}));
			setValidator((current) => ({
				...current,
				cnpj: "true",
			}));
		},
		[values]
	);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Uso Comum"));
			setSemAutorizacaoGerarLogin(!hasRegra("Gerar Login"));
		}
	}, [profile?.token]);

	useEffect(() => {
		setValidator({
			nome: "true",
			cnpj: "true",
		});
	}, [editando, telaCadastro]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="ProprietarioScreenContainer">
						<div className="content-container">
							<div>
								<Separator size="md" />
								<FiltroV2
									classe="div-filtrar-embarque-v2"
									classOption="select-options-cliente"
									itensFiltro={itensFiltro}
									valuesPesquisa={valuesPesquisa}
									setValuesPesquisa={setValuesPesquisa}
									buscarSearch={buscarSearch}
									limpar={limpar}
								/>
							</div>
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="idProprietario"
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.Proprietario}
								dados={dadosTabela}
								nome="veiculo"
								isLoading={loading}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								{!semAutorizacaoGerarLogin && (
									<CustomButtonV2
										classCss="custom-button-vincular"
										classText="button-texto-user"
										titulo="Vincular Usuário"
										cor="#FFFFFF"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setOpenGerar(true);
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
								)}
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer scroll key="ProprietarioCadastroContainer">
						<div className="content-container-scrollable">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">
											{"Cadastro de Proprietário / "}
										</p>
										{editando ? (
											<p className="indicador-emb">
												{"Detalhes de Proprietário"}
											</p>
										) : (
											<p className="indicador-emb">
												{"Cadastro de Proprietário"}
											</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setValuesSelect({});
													setTelaCadastro(false);
													setEditando(false);
													setCnpjMascara("");
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Nome:
												</p>
												<input
													type="text"
													id="nome"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													placeholder="Ex: João"
													maxLength={24}
													value={values.nome || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													CPF/CNPJ:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "270px",
														borderColor:
															validator.cnpj === "false" ? "red" : "",
													}}
													onChange={handleChangeDocumento}
													placeholder="Ex: 00.000.000/0000-00"
													value={values.cnpj || ""}
													disabled={props.desabilitar || editando}
												/>
												{validator.cnpj === "false" && (
													<p className="error-input-text">CNPJ/CPF inválido</p>
												)}
											</div>
										</div>
									</div>
									{isTipoProp && (
										<div className="rota-div-2">
											<div className="input-box-container">
												<div className="input-container">
													<p className="input-label-emb" htmlFor="descricao">
														Tipo Proprietário:
													</p>
													<FormControl sx={{ width: 160 }}>
														<Select
															value={valuesSelect.tipoProprietario}
															options={opcoesSelect}
															formatOptionLabel={label}
															styles={
																!erroTipoProp ? estiloVeiculo : customStylesErro
															}
															placeholder="Selecione"
															noOptionsMessage={() => "Não há mais opções"}
															onChange={(selectedOption) => {
																if (selectedOption) {
																	setValues((current) => ({
																		...current,
																		tipoProprietario: selectedOption.valor,
																	}));
																	setValuesSelect((current) => ({
																		...current,
																		tipoProprietario: selectedOption,
																	}));
																	setValidator((current) => ({
																		...current,
																		tipoProprietario: "true",
																	}));
																	setErroTipoProp(false);
																}
															}}
														/>
													</FormControl>
													{erroTipoProp && (
														<div className="error-text">Obrigatório!</div>
													)}
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
									}}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={cadastrar}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={cadastrar}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setValuesSelect({});
										setTelaCadastro(false);
										setEditando(false);
										setCnpjMascara("");
									}}
								/>
							)}
						</div>
						{editando && (
							<TipoContatoProp
								navbar="nao"
								botaoVoltar="nao"
								botaoCadastrar="nao"
								telaCadastro={false}
								idAtual={props.idAtual}
								desabilitar={props.desabilitar}
								propId={propId}
							/>
						)}
					</MotionContainer>
				)}
			</AnimatePresence>
			<ModalConfirmacao
				titulo="Deletar"
				texto="Deseja Deletar?"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={open}
				onClose={handleClose}
				onClick={deletarEmpresa}
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openUsuario}
				onClose={handleCloseUsuario}
			/>
			<ModalUsuarioMotorista
				titulo="Login Motorista"
				tituloConfirmar="OK"
				open={openUsuarioMotorista}
				onClose={abrirConfirmar}
				dados={dadosUsuarioMotorista}
			/>
			<ModalConfirmacao2
				titulo="Deseja Fechar? "
				texto="Ao fechar esse modal não será mais possivel visalizar a senha."
				textoBotao="Sim"
				open={openConfirmar}
				onClose={handleCloseConfirmar}
				onClick={handleCloseUsuarioMotorista}
			/>
			<ModalVincular
				titulo="Vincular Usuário"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={openGerar}
				onClose={handleCloseGerar}
				onClick={clickGerar}
				listaUsuarios={listaUsuarios}
				setUsuarioId={setUsuarioId}
				setNomeUsuario={setNomeUsuario}
				referenciaId="nome"
				referenciaItem="nome"
				id="id"
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default Proprietario;
